exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nhtml, body {\n  height: 100%;\n  font-family: 'Josefin Sans', sans-serif;\n  color: #fefff6; }\n\n.full-height {\n  height: 100%; }\n\n.row {\n  margin-bottom: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/mdg/Source/markclimb/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/mdg/Source/markclimb/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/mdg/Source/markclimb/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/Users/mdg/Source/markclimb/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles